import { type VBaseInputProps } from '../VBaseInput';
import VInnerTextarea from './VInnerTextarea';
import VInputTextareaWrapper from './VInputTextareaWrapper';
import type { VTextareaProps } from './type';

const VTextarea = ({
  className,
  ref,
  comment,
  disabled,
  fluid,
  id,
  label,
  required,
  style,
  valid,
  ...textareaProps
}: VTextareaProps &
  VBaseInputProps &
  Omit<
    React.ComponentPropsWithRef<'textarea'>,
    'maxLength' | 'minLength' | 'placeholder' | 'ref'
  >) => {
  const baseInputProps = {
    className,
    comment,
    disabled,
    fluid,
    id,
    label,
    required,
    style,
    valid,
  };

  return (
    <VInputTextareaWrapper {...baseInputProps}>
      <VInnerTextarea ref={ref} {...textareaProps} />
    </VInputTextareaWrapper>
  );
};

export default VTextarea;
